import { gql } from "../__generated__";

gql(`
    fragment ActivityLogFields on ActivityLogItem {
        id
        createdAt
        activityName
        activityKey
        badgeUrl
        title
        text
        sourceName
    }
`);

export const GET_ACTIVITY_LOG_FEED = gql(`
    query GetActivityLogs($offset: Int!, $limit: Int!) {
        getActivityLogFeed(offset: $offset, limit: $limit) {
            elements {
                ...ActivityLogFields
            }
             pageInfo {
                currentOffset
                limit
                hasNextPage
                hasPreviousPage
                nextOffset
                previousOffset
            }
        }
    }
`);

export const GET_ACTIVITY_TODO_FEED = gql(`
    query GetActivityTodoFeed {
        getActivityTodoFeed {
            id
            createdAt
            activityName
            activityKey
            title
            text
            priority
            badgeUrl
            sourceName
        }
    }
`);

export const GET_ALL_PROFILES_ACTIVITIES_INFO = gql(`
    query GetAllProfilesActivitiesInfo {
        getAllProfilesActivitiesInfo {
            profileId
            unreadActivities
            unreadTodos
            unreadLogs
        }
    }
`);

export const ACK_ACTIVITY_LOG = gql(`
    mutation AckActivityLog2($logId: UUID!) {
        ackActivityLog2(logId: $logId) {
            hasBeenAcknowledged
            activityLog {
                ...ActivityLogFields
            }
        }
    }
`);

export const ACK_ALL_ACTIVITY_LOG = gql(`
    mutation AckAllActivityLog {
        ackAllActivityLog
    }
`);
